export const RECIEVED_SUCCESS_ORDER = "RECIEVED_SUCCESS_ORDER";
export const RECIEVED_FAILED_ORDER = "RECIEVED_FAILED_ORDER";
export const SET_PROGRESS = "SET_PROGRESS";
export const RECIEVED_SUCCESS_AVAILABLE_DAYS =
  "RECIEVED_SUCCESS_AVAILABLE_DAYS";
export const RECIEVED_FAILED_AVAILABLE_DAYS = "RECIEVED_FAILED_AVAILABLE_DAYS";
